import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FormDateTime } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { LkwCalculatorModal } from "./lkw-calculator-modal";
/** Last-known-well datetime field with a midpoint calculator. */
export function LkwField(_ref) {
  var _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between rounded-sds-200 border border-sds-base-default px-4 py-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t("emergency.calculate_lkw", {
    defaultValue: "Calculate last-known-well"
  })), /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    disabled: disabled,
    "data-testid": "lkw-calc-open-".concat(field.id),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LKW_CALC_OPEN, {
        fieldId: field.id
      });
      setOpen(true);
    },
    className: "text-style-body-small-strong text-teal-400 dark:text-teal-300"
  }, t("emergency.calculate", {
    defaultValue: "Calculate"
  }))), /*#__PURE__*/React.createElement(FormDateTime, {
    label: t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : ""),
    value: String(value !== null && value !== void 0 ? value : ""),
    onChange: onChange,
    testId: "lkw-".concat(field.id)
  }), /*#__PURE__*/React.createElement(LkwCalculatorModal, {
    opened: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    onSave: onChange
  }));
}